import url from './url'
const AppConsts= {
    userManagement:{
        defaultAdminUserName: 'admin'
    },
    localization:{
        defaultLocalizationSourceName: process.env.VUE_APP_NAME.toLowerCase()
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },
    setting: {
        shrink: false,
        confirmLeave: false,
        nroTabs: 12,
        timeout: 240000,
        appName: process.env.VUE_APP_NAME,
    },
    appBaseUrl: "http://localhost:8080",
    remoteServiceBaseUrl: url

}
export default AppConsts